<script lang="ts" setup>
import { useModal } from "vue-final-modal";
import NotifyStudentModal from "./Modal.vue";

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  variant: {
    type: String as PropType<"outlined" | "text">,
    default: "outlined",
  },
  color: {
    type: String,
    default: "primary",
  },
});
</script>

<template>
  <DocumentNotifyStudentModal :document-id="props.documentId">
    <BaseOutlinedButton v-if="variant === 'outlined'" :color="color">
      <div class="flex flex-row items-center">
        <BaseIconSend class="mr-1" />
        <span>Email</span>
      </div>
    </BaseOutlinedButton>
    <BaseTextButton v-else :color="color">
      <div class="flex flex-row items-center">
        <BaseIconSend class="mr-1" />
        <span>Email</span>
      </div>
    </BaseTextButton>
  </DocumentNotifyStudentModal>
</template>

<style scoped></style>
